export const I18n = {
    'en': {
        "contactUsToAccessThis": "Contact info@hankuper.com to access this functionality"
    },
    'ru': {
        "contactUsToAccessThis": "Для доступа к данному функционалу - обратитесь по адресу info@hankuper.com"
    },
    'sk': {
        "contactUsToAccessThis": "Ak chcete získať prístup k tejto funkcii, kontaktujte info@hankuper.com"
    }
};



// WEBPACK FOOTER //
// ./src/I18n/components/sidebar/index.js